// import Vue from 'vue'
// import Vuetify from 'vuetify/lib'
// import theme from './theme'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

// Vue.use(Vuetify, {
//   iconfont: 'mdi',
//   theme
// })

import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import themes from "./theme";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    disable: false,
    dark: false,
    ...themes,
  },
  icons: {
    iconfont: "mdi",
  },
});
